import React, { Fragment } from 'react'
import RenderProfilePicture from '../_helpers/profile-picture'

import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { Spinner } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function ChangeProfilePicture({ profileUrl, uploading, handleUpload, handleError }) {

  return uploading ?
    <Fragment>
      <div className='doctor__photo--uploading' style={{ cursor: 'wait', opacity: .1 }}>
        <RenderProfilePicture
          circle
          image={profileUrl}
          width={150}
          height={150}
          className='my-3 mx-auto axs-shadow'
        />
      </div>
      <div className='uploading__photo d-flex justify-content-center align-items-center' style={{ opacity: 1 }}>
        <Spinner animation='border' />
      </div>
    </Fragment>
    :
    <Fragment>
      <div
        className='doctor__photo'
        style={{ cursor: 'pointer' }}
        onClick={() => document.getElementById('ChangeProfileInput').click()}
      >
        <RenderProfilePicture
          circle
          image={profileUrl}
          width={150}
          height={150}
          className='my-3 mx-auto axs-shadow'
        />
      </div>
      <div className='upload__photo' style={!profileUrl ? { opacity: 1 } : {}}>
        <div className='upload__text'>
          <FontAwesomeIcon icon={faPlus} className='mb-1 axs__light__blue' />
          <br />
          {profileUrl ? 'Change' : 'Upload'} Photo
        </div>
      </div>
      <input
        id='ChangeProfileInput'
        type="file"
        accept=".png, .jpg, .jpeg"
        onClick={e => {
          //
        }}
        onChange={(e) => {
          if (e.target.files.length === 0) {
            return;
          }

          const file = e.target.files[0];
          const reader = new FileReader()

          reader.onloadend = () => {
            handleUpload(reader.result.split(',')[1]);
          }

          reader.onerror = (error) => {
            handleError()
          }

          reader.readAsDataURL(file)
        }}
        style={{ position: 'fixed', opacity: 0, top: 0, left: 0 }}
      />
    </Fragment>
}
